export default function reduce(values, reducer, value) {
    var _a, _b;
    if (typeof reducer !== "function")
        throw new TypeError("reducer is not a function");
    var iterator = values[Symbol.iterator]();
    var done, next, index = -1;
    if (arguments.length < 3) {
        (_a = iterator.next(), done = _a.done, value = _a.value);
        if (done)
            return;
        ++index;
    }
    while ((_b = iterator.next(), done = _b.done, next = _b.value, _b), !done) {
        value = reducer(value, next, ++index, values);
    }
    return value;
}
